import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-040b06bc"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "row",
  style: {"border-radius":"25px","top":"50px"}
}
const _hoisted_2 = { class: "card" }
const _hoisted_3 = {
  key: 0,
  class: "card-body-custom"
}
const _hoisted_4 = ["onClick"]
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "bi bi-eye-fill" }, null, -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"font-size":"14px"} }, null, -1))
const _hoisted_7 = /*#__PURE__*/_createTextVNode("VIEW")
const _hoisted_8 = [
  _hoisted_5,
  _hoisted_6,
  _hoisted_7
]
const _hoisted_9 = ["onClick"]
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"font-size":"14px"} }, " PAY NOW", -1))
const _hoisted_11 = { key: 0 }
const _hoisted_12 = { class: "modal-mask" }
const _hoisted_13 = { class: "modal-wrapper" }
const _hoisted_14 = { class: "modal-container" }
const _hoisted_15 = { key: 0 }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "modal-header" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: "media/icons/bill.png",
    style: {"height":"140px","width":"140px"}
  })
], -1))
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "modal-content mt-3" }, [
  /*#__PURE__*/_createElementVNode("a", { style: {"color":"#9ea0b1","font-size":"16px"} }, "Total Amount")
], -1))
const _hoisted_18 = { class: "modal-content" }
const _hoisted_19 = { style: {"font-size":"16px"} }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))
const _hoisted_21 = { class: "container" }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("h3", null, "ใบแจ้งชำระหนี้ของ Rider"),
  /*#__PURE__*/_createElementVNode("p", { style: {"color":"#9ea0b1"} }, "ยอดค้างชำระ")
], -1))
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))
const _hoisted_24 = {
  class: "modal-footer",
  style: {"margin-top":"30px"}
}
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", { style: {"color":"white","font-size":"14px"} }, "PAY NOW", -1))
const _hoisted_26 = [
  _hoisted_25
]
const _hoisted_27 = {
  key: 1,
  class: "loading"
}
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "dots-1" }, null, -1))
const _hoisted_29 = [
  _hoisted_28
]
const _hoisted_30 = { key: 2 }
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "modal-header" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: "media/icons/bill.png",
    style: {"height":"140px","width":"140px"}
  })
], -1))
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "modal-content mt-3 mb-3" }, [
  /*#__PURE__*/_createElementVNode("h1", { style: {"color":"#4caf50","font-size":"16px","margin-top":"2vh"} }, " SUCCESS! "),
  /*#__PURE__*/_createElementVNode("p", { style: {"color":"#9ea0b1"} }, "Payment is completed")
], -1))
const _hoisted_33 = { class: "box" }
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"display":"flex"} }, [
  /*#__PURE__*/_createElementVNode("div", {
    class: "logo me-1",
    style: {"display":"flex","align-items":"center"}
  }, [
    /*#__PURE__*/_createElementVNode("img", { src: "media/icons/checktrue.svg" })
  ]),
  /*#__PURE__*/_createElementVNode("div", null, [
    /*#__PURE__*/_createElementVNode("div", { style: {"font-size":"16px","font-weight":"bold"} }, " ใบแจ้งชำระหนี้ของ Rider "),
    /*#__PURE__*/_createElementVNode("small", { style: {"color":"#9ea0b1"} }, "ยอดค้างชำระ")
  ])
], -1))
const _hoisted_35 = { style: {"display":"flex","align-items":"center"} }
const _hoisted_36 = {
  key: 0,
  style: {"font-size":"16px","font-weight":"bold"}
}
const _hoisted_37 = { class: "footer" }
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { style: {"color":"#9ea0b1","text-align":"center"} }, " Total Amount ", -1))
const _hoisted_39 = { style: {"text-align":"center"} }
const _hoisted_40 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"color":"white"} }, "Done", -1))
const _hoisted_41 = [
  _hoisted_40
]
const _hoisted_42 = { key: 3 }
const _hoisted_43 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "modal-header" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: "media/icons/bill.png",
    style: {"height":"140px","width":"140px"}
  })
], -1))
const _hoisted_44 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "modal-content mt-3 mb-3" }, [
  /*#__PURE__*/_createElementVNode("h1", {
    style: {"color":"#f44336","font-size":"16px"},
    class: "mt-3"
  }, " PAYMENT ERROR! "),
  /*#__PURE__*/_createElementVNode("p", { style: {"color":"#707070"} }, [
    /*#__PURE__*/_createTextVNode(" Sorry, your transaction has failed. "),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createTextVNode("Please try again later. ")
  ])
], -1))
const _hoisted_45 = { class: "box" }
const _hoisted_46 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"display":"flex"} }, [
  /*#__PURE__*/_createElementVNode("div", {
    class: "logo me-1",
    style: {"display":"flex","align-items":"center"}
  }, [
    /*#__PURE__*/_createElementVNode("img", { src: "media/icons/fail.svg" })
  ]),
  /*#__PURE__*/_createElementVNode("div", null, [
    /*#__PURE__*/_createElementVNode("div", { style: {"font-size":"16px","font-weight":"bold"} }, " ใบแจ้งชำระหนี้ของ Rider "),
    /*#__PURE__*/_createElementVNode("small", { style: {"color":"#9ea0b1"} }, "ยอดค้างชำระ")
  ])
], -1))
const _hoisted_47 = { style: {"display":"flex","align-items":"center"} }
const _hoisted_48 = {
  key: 0,
  style: {"font-size":"16px"}
}
const _hoisted_49 = { class: "footer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_inline_svg = _resolveComponent("inline-svg")!
  const _component_Datatable = _resolveComponent("Datatable")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", null, [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          (_ctx.isLoading == false)
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                _createVNode(_component_Datatable, {
                  "table-header": _ctx.tableHeader,
                  "table-data": _ctx.billList,
                  "enable-items-per-page-dropdown": true,
                  currentPage: _ctx.route.query.current_page,
                  rowsPerPage: _ctx.route.query.row_per_page
                }, {
                  "cell-no": _withCtx(({ row: item }) => [
                    _createElementVNode("span", null, _toDisplayString(item.no), 1)
                  ]),
                  "cell-bill_due_date": _withCtx(({ row: item }) => [
                    _createElementVNode("span", null, _toDisplayString(_ctx.moment(item.bill_due_date).format("DD-MM-YYYY")), 1)
                  ]),
                  "cell-bill_number": _withCtx(({ row: item }) => [
                    _createElementVNode("span", null, _toDisplayString(item.bill_number), 1)
                  ]),
                  "cell-bill_type_name": _withCtx(({ row: item }) => [
                    _createElementVNode("span", null, _toDisplayString(item.bill_type.bill_type_name), 1)
                  ]),
                  "cell-bill_description": _withCtx(({ row: item }) => [
                    _createElementVNode("span", null, _toDisplayString(item.bill_description), 1)
                  ]),
                  "cell-bill_net_price": _withCtx(({ row: item }) => [
                    _createElementVNode("span", null, _toDisplayString(item.bill_net_price), 1)
                  ]),
                  "cell-bill_status": _withCtx(({ row: item }) => [
                    _createElementVNode("div", {
                      class: _normalizeClass([
                    item.bill_status == 1
                      ? 'badge_status--active'
                      : item.bill_status == 2
                      ? 'badge_status--pending'
                      : item.bill_status == 3
                      ? 'badge_status--inactive'
                      : null,
                  ])
                    }, _toDisplayString(item.bill_status == 1
                      ? "PENDING"
                      : item.bill_status == 2
                      ? "PAID"
                      : item.bill_status == 3
                      ? "OVERDUE"
                      : null), 3)
                  ]),
                  "cell-actions": _withCtx(({ row: item }) => [
                    _createElementVNode("span", null, [
                      _createElementVNode("a", {
                        onClick: ($event: any) => (_ctx.toView(item)),
                        class: "btn btn-info",
                        style: {"padding":"2px 10px"}
                      }, _hoisted_8, 8, _hoisted_4),
                      _createElementVNode("button", {
                        onClick: ($event: any) => (_ctx.Popuppage(item)),
                        class: "btn btn-success",
                        style: {"padding":"2px 10px","margin-left":"1vw"}
                      }, [
                        _createVNode(_component_inline_svg, { src: "media/icons/billcard.svg" }),
                        _hoisted_10
                      ], 8, _hoisted_9)
                    ])
                  ]),
                  _: 1
                }, 8, ["table-header", "table-data", "currentPage", "rowsPerPage"])
              ]))
            : _createCommentVNode("", true)
        ])
      ]),
      (_ctx.check)
        ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
            _createVNode(_Transition, { name: "modal" }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_12, [
                  _createElementVNode("div", _hoisted_13, [
                    _createElementVNode("div", _hoisted_14, [
                      (_ctx.slidepage)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                            _hoisted_16,
                            _hoisted_17,
                            _createElementVNode("div", _hoisted_18, [
                              _createElementVNode("h1", _hoisted_19, _toDisplayString(_ctx.credit.bill_net_price + " credit"), 1)
                            ]),
                            _hoisted_20,
                            _createElementVNode("div", _hoisted_21, [
                              _hoisted_22,
                              _createElementVNode("div", null, [
                                _createElementVNode("h3", null, _toDisplayString(_ctx.credit.bill_net_price), 1)
                              ])
                            ]),
                            _hoisted_23,
                            _createElementVNode("div", _hoisted_24, [
                              _createElementVNode("button", {
                                class: "button",
                                onClick: _cache[0] || (_cache[0] = ($event: any) => {
                        _ctx.slidepage = false;
                        _ctx.toPay(_ctx.credit);
                      })
                              }, _hoisted_26),
                              _createElementVNode("h5", {
                                class: "cancel-text",
                                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.check = false))
                              }, "CANCEL")
                            ])
                          ]))
                        : (_ctx.isLoadingPage)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_27, _hoisted_29))
                          : (_ctx.setbillpaycheck.bill_complete.length > 0)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_30, [
                                _createElementVNode("div", null, [
                                  _hoisted_31,
                                  _hoisted_32,
                                  _createElementVNode("div", _hoisted_33, [
                                    _hoisted_34,
                                    _createElementVNode("div", _hoisted_35, [
                                      (_ctx.setbillpaycheck.bill_complete.length > 0)
                                        ? (_openBlock(), _createElementBlock("span", _hoisted_36, _toDisplayString(_ctx.setbillpaycheck.bill_complete[0].bill_net_price), 1))
                                        : _createCommentVNode("", true)
                                    ])
                                  ]),
                                  _createElementVNode("div", _hoisted_37, [
                                    _createElementVNode("div", null, [
                                      _createElementVNode("div", null, [
                                        _hoisted_38,
                                        _createElementVNode("h1", _hoisted_39, _toDisplayString(_ctx.setbillpaycheck.bill_net_price) + " Credit ", 1)
                                      ]),
                                      _createElementVNode("button", {
                                        class: "button",
                                        onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.Done())),
                                        style: {"font-size":"14px","font-weight":"bold"}
                                      }, _hoisted_41)
                                    ])
                                  ])
                                ])
                              ]))
                            : (_ctx.setbillpaycheck.bill_fail.length > 0)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_42, [
                                  _createElementVNode("div", null, [
                                    _hoisted_43,
                                    _hoisted_44,
                                    _createElementVNode("div", _hoisted_45, [
                                      _hoisted_46,
                                      _createElementVNode("div", _hoisted_47, [
                                        (_ctx.setbillpaycheck.bill_fail.length > 0)
                                          ? (_openBlock(), _createElementBlock("b", _hoisted_48, _toDisplayString(_ctx.setbillpaycheck.bill_fail[0].bill_net_price), 1))
                                          : _createCommentVNode("", true)
                                      ])
                                    ]),
                                    _createElementVNode("div", _hoisted_49, [
                                      _createElementVNode("div", null, [
                                        _createElementVNode("button", {
                                          class: "button",
                                          onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.Done())),
                                          style: {"font-size":"14px","font-weight":"bold"}
                                        }, " Done ")
                                      ])
                                    ])
                                  ])
                                ]))
                              : _createCommentVNode("", true)
                    ])
                  ])
                ])
              ]),
              _: 1
            })
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}